/**
 * Created by valerasiestov on 28.01.16.
 */


if (!window.module) {
    window.module = {};
}

module.scrollSlide = (function () {
    "use strict";

    var scrollTween,
        controls = {
            scrollTime: 0.3,
            scrollDistance: 150,
            scrollActivity: 1,
            maxScrollActivity: 4,
            desktop: matchMedia('(min-width: 1024px)')
        },
        handlers = {
            scroll: function () {
                var position = window.scrollTop || document.documentElement.scrollTop || document.body.scrollTop,
                    opacity = 1 - position / controls.height;

                if (opacity === 0) {
                    return;
                }

                if (controls.layout && controls.layout.style) {
                    controls.layout.style.cssText = 'opacity: ' + opacity + ';' + 'transform: translate3d(0, ' + (position - (1 - opacity) * controls.height / 2) + 'px, 0);';
                }
                if (controls.image && controls.image.style) {
                    controls.image.style.cssText = 'transform: scale(' + (1 + 0.3 * (1 - opacity)) + ') translate3d(0, 0, 0);';
                }
            },

            resize: function () {
                handlers.getSizes();

                if (controls.desktop.matches) {
                    if (controls.layout && controls.layout.style) {
                        controls.layout.style.cssText = '';
                    }
                    if (controls.layout && controls.image.style) {
                        controls.image.style.cssText = '';
                    }
                }
            },
            
            getSizes: function () {
                controls.height = window.innerHeight;
            },

            mouseWheel: function(event) {

                // set new scroll distance if scrolling is fast
                var newDistance = controls.scrollDistance,
                    newActivity;
                if (scrollTween) {
                    if (scrollTween.isActive()) {
                        newActivity = Math.abs(event.originalEvent.wheelDelta) * 0.001;
                        controls.scrollActivity *= (1 + newActivity);
                        controls.scrollActivity = controls.scrollActivity > controls.maxScrollActivity ? controls.maxScrollActivity : controls.scrollActivity;
                        newDistance = controls.scrollDistance * controls.scrollActivity;
                    } else {
                        controls.scrollActivity = 1;
                        newDistance = controls.scrollDistance;
                    }

                }

                if (!controls.desktop.matches) {
                    return;
                }

                event.preventDefault();

                var delta = event.originalEvent.wheelDelta/120 || -event.originalEvent.detail/3;
                var scrollTop = controls.$window.scrollTop();
                var finalScroll = scrollTop - parseInt(delta * newDistance);

                scrollTween = TweenMax.to(controls.$window, controls.scrollTime, {
                    scrollTo : { y: finalScroll, autoKill:true },
                    ease: Power1.easeOut,
                    autoKill: true,
                    overwrite: 5
                });

            }
        };

    function setEventList() {
        window.addEventListener('scroll', handlers.scroll, false);
        window.addEventListener('resize', handlers.resize, false);

        if (!FRONDEVO.browser.browser.firefox) {
            //$(controls.wrap).on("mousewheel DOMMouseScroll", handlers.mouseWheel);
            $(window).on("mousewheel DOMMouseScroll", handlers.mouseWheel);
        }
    }

    function getControls() {
        var wrap;

        controls.$window = $(window);
        controls.wrap = wrap = document.querySelector('.full-height.inner');
        //controls.image = wrap.querySelector('picture');
        controls.image = $(wrap).find('picture');
        //controls.layout = wrap.querySelector('.full-height__layout');
        controls.layout = $(wrap).find('.full-height__layout');

        handlers.getSizes();
    }

    function init(params) {
        getControls();
        setEventList();
    }

    return {
        init: init
    };

}());

window.addEventListener('DOMContentLoaded', function () {

    module.scrollSlide.init({

    });

}, false);
